<form #form="ngForm" novalidate>
    <ng-template [ngIf]="cliente">
        <div class="row" *ngIf="showCliente">
            <div class="form-group col-12">
                <label class="col-form-label">Cliente</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">{{cliente.codigoIntegracaoErp}}</span>
                    </div>
                    <input type="text" class="form-control" [value]="cliente.nome | clienteNome: cliente.nomeFantasia" disabled="disabled" readonly="readonly">
                </div>                                
            </div>
        </div> 

        <div class="row" *ngIf="showRepresentante">
            <div class="form-group col-12">
                <label class="col-form-label">Representante</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">{{cliente.codigoIntegracaoErpRepresentante}}</span>
                    </div>
                    <input type="text" class="form-control" [value]="cliente.nomeRepresentante | representanteNome: cliente.nomeFantasiaRepresentante" disabled="disabled" readonly="readonly">
                </div>                                
            </div>
        </div>  

        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label d-block pb-0">Status</label>
                <sgt-cliente-analise-financeira-status-badge
                    [status]="cliente.statusAnaliseFinanceira">
                </sgt-cliente-analise-financeira-status-badge>
            </div>
        </div>        
        
        <!-- Inicio -->
        <ng-template [ngIf]="config?.isStatusEmAnalise || config?.isStatusConcluida">
            <div class="row">
                <div class="form-group col-12 col-md">
                    <label class="col-form-label">Iniciada Em</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                                <i class="fas fa-play"></i>
                          </span>
                        </div>
                        <input type="text" class="form-control" [value]="cliente.dataInicioAnaliseFinanceira | date: 'dd/MM/yyy HH:mm:ss'" disabled="disabled" readonly="readonly">
                    </div>                                
                </div>
                <div class="form-group col-12 col-md">
                    <label class="col-form-label">Iniciada Por</label>
                    <input type="text" class="form-control" [value]="cliente.nomeUsuarioInicioAnaliseFinanceira" disabled="disabled" readonly="readonly">                 
                </div>                        
            </div>
        </ng-template>

        <!-- Conclusão -->
        <ng-template [ngIf]="config?.isStatusConcluida">
            <div class="row">
                <div class="form-group col-12 col-md">
                    <label class="col-form-label">Concluída Em</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                                <i class="fas fa-check"></i>
                          </span>
                        </div>
                        <input type="text" class="form-control" [value]="cliente.dataConclusaoAnaliseFinanceira | date: 'dd/MM/yyy HH:mm:ss'" disabled="disabled" readonly="readonly">
                    </div>                                
                </div>
                <div class="form-group col-12 col-md">
                    <label class="col-form-label">Concluída Por</label>
                    <input type="text" class="form-control" [value]="cliente.nomeUsuarioConclusaoAnaliseFinanceira" disabled="disabled" readonly="readonly">                 
                </div>                        
            </div>
        </ng-template>      
        
        <!-- Revisão -->
        <ng-template [ngIf]="config?.isStatusConcluida && cliente.dataUltimaRevisaoAnaliseFinanceira">
            <div class="row">
                <div class="form-group col-12 col-md">
                    <label class="col-form-label">Revisada Em</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="far fa-edit"></i>
                            </span>
                        </div>
                        <input type="text" class="form-control" [value]="cliente.dataUltimaRevisaoAnaliseFinanceira | date: 'dd/MM/yyy HH:mm:ss'" disabled="disabled" readonly="readonly">
                    </div>                                
                </div>
                <div class="form-group col-12 col-md">
                    <label class="col-form-label">Revisada Por</label>
                    <input type="text" class="form-control" [value]="cliente.nomeUsuarioUltimaRevisaoAnaliseFinanceira" disabled="disabled" readonly="readonly">                 
                </div>                        
            </div>
        </ng-template> 
        
        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label" for="anotacaoAnaliseFinanceira">Anotação</label>
                <ng-template [ngIf]="canEdit">
                    <textarea class="form-control" [(ngModel)]="cliente.anotacaoAnaliseFinanceira" #textAreaAnotacao name="anotacaoAnaliseFinanceira" id="anotacaoAnaliseFinanceira" 
                        #anotacaoAnaliseFinanceira="ngModel" #textareaAnotacao rows="10" required="required" minlength="15">
                    </textarea>      
                    <sgt-form-control-error
                        *ngIf="anotacaoAnaliseFinanceira.errors && anotacaoAnaliseFinanceira.errors.required && anotacaoAnaliseFinanceira.dirty"
                        msgError="A anotação é obrigatória">
                    </sgt-form-control-error>                           
                    <sgt-form-control-error
                        *ngIf="anotacaoAnaliseFinanceira.errors && anotacaoAnaliseFinanceira.errors.minlength"
                        msgError="A anotação deve ter no mínimo 15 caracteres">
                    </sgt-form-control-error>                          
                </ng-template>
    
                <ng-template [ngIf]="!canEdit">
                    <textarea class="form-control" [value]="cliente.anotacaoAnaliseFinanceira"
                        rows="5" disabled="disabled" readonly="readonly">
                    </textarea>   
                </ng-template>
            </div>
        </div>
    </ng-template>
</form>